module.exports = __webpack_public_path__ + "img/transcript_bg.889f9d98.jpg";